import { Badge, Grid } from "@mui/material";
import dayjs from "dayjs";
import { CiFileOn } from "react-icons/ci";
import { AppointmentType } from "../../../../components/modals/bookingModalComponents/context/BookingModalContext";
import AppointmentWrapper from "../../../../components/wrappers/AppointmentWrapper";
import usePrimaryColor from "../../../../hooks/usePrimaryColor";
import useServiceTranslation from "../../../../hooks/useServiceTranslation";
import { getDateObject } from "../../../../utils/DateTimeRepository";
import { trimText } from "../../../../utils/Functions";
import AppointmentShortInfo from "./AppointmentShortInfo";
import useUser from "../../../../hooks/useUser";
import { useTranslation } from "react-i18next";

export default function SingleAppointment({ buttonProps, appointment, isOwnerDeleted = false, fullWidth = false }) {
  const color = usePrimaryColor();
  const { roles, currentClinic } = useUser();
  const { t } = useTranslation();
  function dateParse() {
    const startDateTime = dayjs(getDateObject(appointment?.startDate)).format(
      "DD/MM/YYYY, HH:mm",
    );
    if (appointment?.endDate) {
      const endDateTime = dayjs(getDateObject(appointment?.endDate)).format(
        "HH:mm",
      );
      return String(startDateTime) + " - " + String(endDateTime);
    }
    return String(startDateTime);
  }
  const shouldShowClinicName = () => {
    if (roles?.user || roles?.master) {
      return true;
    } else if (roles?.adminOrEmployee) {
      if (!currentClinic?.id || !appointment?.clinic?.id) {
        return false;
      }
      return currentClinic.id !== appointment.clinic.id;
    }
    return false;
  };

  const getClinicNameString = () => {
    if (!shouldShowClinicName()) {
      return null;
    }

    if (appointment?.clinicName) {
      return `${appointment?.clinicName} - ${appointment?.clinicAddress}`;
    } else if (appointment?.clinic) {
      return `${appointment?.clinic?.title} - ${appointment?.clinic?.streetAddress}, ${appointment?.clinic?.city}`;
    }

    return null;
  };
  
const getUserDisplayString = () => {
    if (isOwnerDeleted) {
      return t("DeletedUser");
    } else if (appointment?.user?.userDetails?.email) {
      return appointment.user.userDetails.email;
    } else if (appointment?.ownerEmail) {
      return appointment.ownerEmail;
    } else if (appointment?.user?.fullName) {
      return appointment.user.fullName;
    } else if (appointment.ownerName) {
      return appointment.ownerName;
    }
    return null; 
  };

  return (
    <AppointmentWrapper
      fullWidth={fullWidth}
      id={appointment?.id}
      buttonProps={buttonProps}
      status={appointment?.status}
    >
      <Grid container alignItems="center">
        {/* Left Section */}
        <Grid item xs={10}>
          <AppointmentShortInfo
            petName={trimText(
              appointment?.pet ? appointment?.pet?.name : appointment?.petName,
              30,
            )}
            date={dateParse()}
            type={useServiceTranslation(appointment[AppointmentType])}
            user={getUserDisplayString()}
            clinicName={getClinicNameString()} // Conditionally show clinic name
          />
        </Grid>

        {/* Right Section */}
        <Grid item xs={2} display="flex" justifyContent="flex-end">
          {appointment?.numOfFiles > 0 ? (
            <Badge
              badgeContent={appointment?.numOfFiles}
              color="info"
              sx={{
                position: "relative",
                right: 10,
              }}
            >
              <CiFileOn size={35} color={color} />
            </Badge>
          ) : null}
        </Grid>
      </Grid>
    </AppointmentWrapper>
  );
}
